import React, { useState, useEffect, useRef } from "react";
import api from '../api/api';
import { useTranslation } from "react-i18next";
import ChatComponent from "./ChatComponentMobile";
import { IoMdSend } from 'react-icons/io';

const MatchRequestCardMobile = ({ request, user, onRespond, onRecenterMap, event, refreshMatchRequests }) => {
  const [receiver, setReceiver] = useState(null);
  const [sender, setSender] = useState(null);
  const [eventTitle, setEventTitle] = useState("");
  const [isReceiver, setIsReceiver] = useState(false);
  const [isSender, setIsSender] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [message, setMessage] = useState("");
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [sentSuccess, setSentSuccess] = useState(false);
  const { t } = useTranslation();
  const longPressTimeout = useRef(null);
  const [longPressing, setLongPressing] = useState(false);

  useEffect(() => {
    const fetchParticipantDetails = async () => {
      const receiverResponse = await api.get(`/api/participants/${request.receiver_id}`);
      const senderResponse = await api.get(`/api/participants/${request.sender_id}`);
      const eventResponse = await api.get(`/api/events/${request.event_id}`);

      if (receiverResponse.status === 200) setReceiver(receiverResponse.data);
      if (senderResponse.status === 200) setSender(senderResponse.data);
      if (eventResponse.status === 200) setEventTitle(eventResponse.data.title);
    };

    fetchParticipantDetails();
  }, [request]);

  useEffect(() => {
    setIsReceiver(receiver && user && receiver.email === user.email);
    setIsSender(sender && user && sender.email === user.email);
  }, [receiver, sender, user]);

  const handleCardClick = () => {
    if (isReceiver && sender) {
      onRecenterMap(sender.latitude, sender.longitude);
    } else if (isSender && receiver) {
      onRecenterMap(receiver.latitude, receiver.longitude);
    }
  };

  const confirmCancelRequest = async () => {
    try {
      await api.delete(`/api/match-requests/${request.id}`, {
	    data: {
	      my_participant_id: isSender ? sender.id : receiver.id,
	    },
	  });
      await api.post("/api/participants/send_match_cancel_email", {
        receiver_email: receiver.email,
        sender_name: sender.name,
        event_title: eventTitle
      });
      setShowCancelModal(false);
      refreshMatchRequests();
    } catch (error) {
      console.error("❌ Erreur lors de l'annulation de la demande :", error);
      alert("Erreur lors de l'annulation de la demande.");
    }
  };

  return (
    <div
      className="match-request-card select-none"
      onClick={handleCardClick}
      onTouchStart={() => {
        setLongPressing(true);
        longPressTimeout.current = setTimeout(() => {
          setShowCancelModal(true);
          setLongPressing(false);
        }, 600);
      }}
      onTouchEnd={() => {
        clearTimeout(longPressTimeout.current);
        setLongPressing(false);
      }}
      onTouchMove={() => {
        clearTimeout(longPressTimeout.current);
        setLongPressing(false);
      }}
    >
      <div className={`p-4 border rounded-lg shadow-md bg-white flex justify-between items-center cursor-pointer ${longPressing ? 'bg-red-50' : ''}`}>
        <div className="left-side flex flex-col items-start">
          <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
            {isReceiver && sender ? sender.name : isSender && receiver ? receiver.name : ''}
          </span>
          <span className="text-gray-400 text-xs mt-1">{t('dashboard.long_press_cancel')}</span>
        </div>
        <div className="right-side">
          <button
            className="action-button bg-blue-500 text-white rounded-lg hover:bg-blue-600 flex items-center justify-center"
            onClick={(e) => {
              e.stopPropagation();
              setLoadingEmail(false);
              setSentSuccess(false);
              setShowContactModal(true);
            }}
            style={{ padding: '8px 8px' }}
          >
            <IoMdSend className="icon-size" />
          </button>
        </div>
      </div>

      {showContactModal && sender && receiver && (
        <ChatComponent
          matchRequestId={request.id}
          participantId={isSender ? sender.id : receiver.id}
          onMessageSent={(msg) => setMessage(msg)}
          onClose={() => setShowContactModal(false)}
        />
      )}

      {showCancelModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
          <div className="modal-mobile bg-white rounded-lg shadow-lg p-4 w-full max-w-md mx-4">
            <h2 className="text-xl font-bold text-gray-800 mb-4">{t('dashboard.confirmation')}</h2>
            <p className="text-gray-600 mb-6">{t("dashboard.confirm_cancel_request")}</p>
            <div className="flex justify-evenly space-x-2">
              <button
                onClick={() => setShowCancelModal(false)}
                className="flex-1 px-4 py-3 text-gray-600 border border-gray-400 rounded-md hover:bg-gray-100 transition-all"
              >
                {t("dashboard.cancel")}
              </button>
              <button
                onClick={confirmCancelRequest}
                className="flex-1 px-4 py-3 bg-red-500 text-white rounded-md hover:bg-red-600 transition-all"
              >
                {t("dashboard.confirm")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MatchRequestCardMobile;
